import { Validator } from 'vee-validate';
import i18n from '@/i18n/i18n';
import { businessNameRegex } from '@/util/util.regex';

Validator.extend('businessName', {
  getMessage: (field) => i18n.t('$Validators.businessName', { field }),
  validate: (value) => businessNameRegex.test(value),
});
